export default __webpack_public_path__ + "static/media/economiaNaranja.6d0ce6ad.jpg";